import { render, staticRenderFns } from "./gantt-chart.vue?vue&type=template&id=396366be&scoped=true&"
import script from "./gantt-chart.component.ts?vue&type=script&lang=ts&"
export * from "./gantt-chart.component.ts?vue&type=script&lang=ts&"
import style0 from "./gantt-chart.scss?vue&type=style&index=0&id=396366be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396366be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('396366be')) {
      api.createRecord('396366be', component.options)
    } else {
      api.reload('396366be', component.options)
    }
    module.hot.accept("./gantt-chart.vue?vue&type=template&id=396366be&scoped=true&", function () {
      api.rerender('396366be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery-wellcome/components/gantt-chart/gantt-chart.vue"
export default component.exports